<template>
  <a-button block class="table-cell__actions-btn" type="text" @click="handleShowModal">
    <template #icon>
      <PlayCircleOutlined />
    </template>

    <a-modal
      v-model:visible="visible"
      v-if="visible"
      centered
      width="520px"
      :mask-closable="false"
      :keyboard="false"
      :footer="null"
    >
      <template #title> Audio de la estrategia </template>
      <div class="modal__body">
        <section class="section">
          <a-space direction="vertical" :size="3" style="width: 100%">
            <div class="section__item">
              <a-typography-text strong> Estado de la estrategia: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">
                <a-tag v-if="strategy.strategy_status" :color="StrategyColor?.[strategy.strategy_status]?.tag">
                  <component :is="imageStrategy(strategy.strategy_status)" />
                  {{ StrategyText[strategy.strategy_status] }}
                </a-tag>
              </span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Nombre de la estrategia: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ strategy.name }}</span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Tipo de creación: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ strategy.type_origin == 1 ? 'Por filtros' : 'Por plantillas' }}</span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Tipo de estrategia: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ strategy.type_strategy_name }}</span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Tipo de asignación: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ TYPES_ASSIGNMENT[strategy.type_assignment] || "-" }}</span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Empresa: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ strategy.entity.name }}</span>
            </div>
            <div class="section__item">
              <a-typography-text strong> Campaña: </a-typography-text>
              <span class="mrg-bottom-0 gray-8">{{ strategy.portfolio.name }}</span>
            </div>
            <div class="section__item" style="margin-top: 20px">
              <CallAudioPlayer
                :audio-url="audioUrl"
                volumen="vertical"
              />
            </div>
          </a-space>
        </section>
      </div>
    </a-modal>
    <p>Escuchar audio</p>
  </a-button>
</template>

<script>
import { updateIvrOptions } from "@/app/strategies/services";
import { IvrDerivation } from "@/app/strategies/utils/enums";
import { PlayCircleOutlined } from "@ant-design/icons-vue";
import { StrategyColor, StrategyImageName, StrategyText } from "@/app/shared/utils/enums";
import { TYPES_ASSIGNMENT } from "../../utils/modalStrategy";
import CallAudioPlayer from "@/app/supervision/components/audio/CallAudioPlayer.vue";
import { downloadAudioIvr } from "@/app/strategies/services";

export default {
  components: {
    PlayCircleOutlined,
    CallAudioPlayer,
  },
  props: {
    strategy: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      IvrDerivation,
      visible: false,

      file: null,
      typeIvrDerivation: IvrDerivation.informative,
      loading: false,
      StrategyColor,
      StrategyImageName,
      StrategyText,
      TYPES_ASSIGNMENT,
      audioUrl: "",
    };
  },
  computed: {
    isInformative() {
      return this.typeIvrDerivation === IvrDerivation.informative;
    },
  },
  methods: {
    handleCancel() {
      this.file = null;
      this.visible = false;
    },
    handleShowModal() {
      this.visible = true;
    },
    imageStrategy(text) {
      return StrategyImageName[text];
    },
  },
  async mounted() {
    try {
      const blob = await downloadAudioIvr(this.strategy.id);
      this.audioUrl = URL.createObjectURL(blob);
    } catch (e) {
      message.warning("No se pudo reproducir el audio");
    }
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    color: $gray-9

.info
  display: flex
  margin: 8px 0 20px 0

  &__icon
    margin: 4px 8px 0 2px

  &__text
    color: $gray-7

.title
  &__icon
    margin-left: 4px

.radio
  display: block
  height: 30px
  line-height: 30px
</style>
